import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { yelp, facebook, instagram, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column justifyStart>
          <CFView h3 futura bold color="#D1AE85" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center white bold>
            <CFLink href="https://www.facebook.com/sushicalivan/">
              <CFImage
                w="40px"
                pr="10px"
                src={facebook}
                alt="Sushi California Facebook"
              />
            </CFLink>
            {/* <CFLink href="https://www.yelp.ca/biz/chicko-chicken-coquitlam">
              <CFImage
                w="40px"
                pr="10px"
                src={yelp}
                alt="Sushi California Yelp"
              />
            </CFLink>
            <CFLink href="https://www.zomato.com/victoria-bc/chimac-korean-pub-and-fried-chicken-victoria-city-of-victoria">
              <CFImage
                w="40px"
                pr="10px"
                src={zomato}
                alt="Sushi California Zomato"
              />
            </CFLink> */}
            <CFLink href="https://www.instagram.com/sushicalivan/?hl=en">
              <CFImage
                w="40px"
                pr="10px"
                src={instagram}
                alt="Sushi California Instagram"
              />
            </CFLink>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h3 futura bold color="#D1AE85" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter white bold>
            <CFLink href="https://www.facebook.com/sushicalivan/">
              <CFImage
                w="40px"
                pr="10px"
                src={facebook}
                alt="Sushi California Facebook"
                hover
              />
            </CFLink>
            {/* <CFLink href="https://www.yelp.ca/biz/chicko-chicken-coquitlam">
              <CFImage
                w="40px"
                pr="10px"
                src={yelp}
                alt="Sushi California Yelp"
                hover
              />
            </CFLink>
            <CFLink href="https://www.zomato.com/victoria-bc/chimac-korean-pub-and-fried-chicken-victoria-city-of-victoria">
              <CFImage
                w="40px"
                pr="10px"
                src={zomato}
                alt="Sushi California Zomato"
                hover
              />
            </CFLink> */}
            <CFLink href="https://www.instagram.com/sushicalivan/?hl=en">
              <CFImage
                w="40px"
                pr="10px"
                src={instagram}
                alt="Sushi California Instagram"
              />
            </CFLink>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
